export default "__VITE_ASSET__B0Z26uES__"